import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { unwrapResult } from '@reduxjs/toolkit';

import { SIGNUP_PATHS } from '../../../../constants';
import { useUserToken } from '../../../../hooks/userTokenHook';
import IconBtn from '../../../../modules/icon-btn/icon-btn';
import LoadDocBtn from '../../../../modules/load-doc-btn';
import UiTextarea from '../../../../modules/ui/ui-textarea/ui-textarea';
import { useAppDispatch } from '../../../../store';
import {
  checkRegistrationStep,
  getAccessionDoc,
  getAccessionDocText,
  uploadAccessionDoc,
} from '../../../../store/actions/signup';
import { RootState } from '../../../../types';
import {
  downloadFile,
  getPdfFromBase64,
} from '../../../../utils/files/downloadFile';
import FormFooter from '../form-footer/form-footer';
import FormHeader from '../form-header/form-header';
import UserIcon from '../icons/user-icon.svg';

const AgreementStep: React.FC = () => {
  const dispatch = useAppDispatch();
  const { token } = useUserToken();
  const history = useHistory();
  const accessionDocText = useSelector(
    (s: RootState) => s.signup.accessionDocText
  );
  const isLoadingAccessionDoc = useSelector(
    (s: RootState) => s.signup.loading.getAccessionDoc
  );
  const accessionDoc = useSelector((s: RootState) => s.signup.accessionDoc);
  const step = useSelector((s: RootState) => s.signup.step);

  useEffect(() => {
    dispatch(getAccessionDoc());
    dispatch(getAccessionDocText());

    if (!token) history.push(SIGNUP_PATHS.CODE);

    if (step && step !== 'ACCESSION_AGREEMENT') {
      history.push(SIGNUP_PATHS.NEW);
    }
  }, []);

  const onSubmit = useCallback(() => {
    dispatch(uploadAccessionDoc()).then((action) => {
      if (action.meta.requestStatus === 'fulfilled') {
        dispatch(checkRegistrationStep({ token }))
          .then(unwrapResult)
          .then((profileAction) => {
            if (profileAction && profileAction.status === 'PASSWORD_CREATION')
              history.push(SIGNUP_PATHS.PASSWORD);
          });
      }
    });
  }, [uploadAccessionDoc, checkRegistrationStep]);

  const onSpecDownload = useCallback((accessionDoc) => {
    const resultBlob = getPdfFromBase64(
      accessionDoc,
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    );
    downloadFile(
      resultBlob,
      'Договор_о_присоединении.docx',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    );
  }, []);

  return (
    <form className="login-form login-form--6">
      <FormHeader
        flex
        bigTitle="Регистрация"
        title="Ознакомьтесь с Пользовательским соглашением:"
        flexRight={
          accessionDoc && (
            <LoadDocBtn
              title="Пользовательское соглашение"
              extension=".DOCX"
              onSpecDownload={() => onSpecDownload(accessionDoc)}
            />
          )
        }
      />
      <div className="login-form__body">
        {accessionDocText && (
          <div className="login-form__textaria">
            <UiTextarea
              disabled
              className="textarea"
              id="massage"
              name="massage"
            >
              {accessionDocText}
            </UiTextarea>
          </div>
        )}
      </div>
      <FormFooter
        actions={
          <IconBtn
            disabled={isLoadingAccessionDoc}
            onClick={onSubmit}
            icon={UserIcon}
            title="Принять Пользовательское соглашение"
            lg
          />
        }
      />
    </form>
  );
};

export default AgreementStep;
